import { Component, Input, inject, Output, EventEmitter, Pipe, PipeTransform, OnInit, ChangeDetectorRef } from "@angular/core";
import { CommonModule, AsyncPipe } from '@angular/common';
import { Patient } from '../Api/DcoApi/Patient'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { NP } from "./Popups/Notfallplan";
import { UserEdit } from "./Popups/UserEdit";
import { KontaktEdit } from "./Popups/KontacktEdit";
import { RestClient } from "../Api/DcoApi/Client/RestClient";
import { IsSpezialUserDirective, IsWelcomeCallDirective } from "../Admin/AdminGuard";
import {PhoneCall} from '../Componente/PhoneCall';
import {StepItem, StepperComponent} from '../Componente/stepper';

@Pipe({
  name: "yesNo"
})
export class YesNoPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return value ? "ja" : "nein";
  }
}

@Pipe({
  name: "gkv"
})
export class GKVPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return value ? "GKV" : "PKV";
  }
}

@Component({
  imports: [
    CommonModule,
    GKVPipe, PhoneCall,
    YesNoPipe, IsWelcomeCallDirective, IsSpezialUserDirective, StepperComponent
  ],
  selector: 'Akte-Patient',
  templateUrl: './Akte.Patient.html',
  styleUrl: './Akte.Patient.css'
})

export class Akte_Patient implements OnInit {
  @Input() Patient: Patient | null | undefined = null;
  @Output() PatientChange = new EventEmitter<Patient | null>();
  private modalService = inject(NgbModal);
  @Input() OrderStep: number | null | undefined = null;
  Client: RestClient;

  ngOnInit() {
    console.log(this.Patient);
  }

  constructor(private cdr: ChangeDetectorRef) {
    this.Client = new RestClient();
  }

  openNotfallplan() {
    const modalRef = this.modalService.open(NP);
    modalRef.componentInstance.VersichertenNR = this.Patient?.versicherungsnummer;
  }

  openUser() {
    const modalRef = this.modalService.open(UserEdit);
    modalRef.componentInstance.patient = this.Patient;
    modalRef.componentInstance.KvNummer = this.Patient?.versicherungsnummer;
    modalRef.closed.subscribe({
      next: async (config) => {
        try {
          this.PatientChange.emit(await this.Client.Get<Patient>(`/Backend/Api/V2/Akte/${this.Patient?.versicherungsnummer?.replaceAll('_', '')}/Patient`))
        }catch {}


    },
      error: (err) => {


      },
    });
    modalRef.dismissed.subscribe({
      next: async (config) => {
        try {
          this.PatientChange.emit(await this.Client.Get<Patient>(`/Backend/Api/V2/Akte/${this.Patient?.versicherungsnummer?.replaceAll('_', '')}/Patient`))
        }catch {}


      },
      error: (err) => {


      },
    });
  }

  openKontackt() {
    const modalRef = this.modalService.open(KontaktEdit);
    modalRef.componentInstance.VersichertenNR = this.Patient?.versicherungsnummer;
  }

  StatusList: StepItem[] = [
    {label: 'Vorbereitung', icon: 'fa-solid fa-spinner'},
    {label: 'EKV', icon: 'fa-solid fa-section'},
    {label: 'Versand', icon: 'fa-solid fa-truck-ramp-box'},
    {label: 'In Betrieb', icon: 'fa-solid fa-tower-cell'},
    {label: 'Rückholung', icon: 'fa-solid fa-person-walking-arrow-loop-left'},
    {label: 'Beendet', icon: 'fa-solid fa-flag-checkered'},
  ];

}
